package com.advaita.cloud.drive.ui.components

import androidx.compose.runtime.Composable
import com.advaita.cloud.drive.ui.store.BulkItemState
import com.advaita.cloud.drive.ui.store.FileBrowserStore
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

/**
 * ADV-1463: the bulk-delete pop-up. A bar with "N of M", and a list with the state of each item.
 * The list scrolls past 8 rows. The store closes it 3 s after a batch with no failure.
 */
@Composable
fun BulkDeleteProgress(store: FileBrowserStore) {
    val state = store.bulkDelete ?: return
    val percent = if (state.total == 0) 0 else state.finished * 100 / state.total
    Div(attrs = { classes("bulk-delete-popup"); attr("role", "status"); attr("aria-live", "polite") }) {
        Div(attrs = { classes("bulk-delete-head") }) {
            Span { Text(if (state.over) "Deleted ${state.total - state.failed} of ${state.total}" else "Deleting ${state.total} item${if (state.total == 1) "" else "s"}") }
            Button(attrs = { classes("bulk-delete-close"); attr("aria-label", "Close"); onClick { store.closeBulkDelete() } }) { Text("×") }
        }
        Div(attrs = { classes("upload-progress-bar") }) {
            Div(attrs = { classes("upload-progress-fill"); style { property("width", "$percent%") } }) {}
        }
        Div(attrs = { classes("bulk-delete-count") }) { Text("${state.finished} of ${state.total}") }
        Div(attrs = { classes("bulk-delete-list") }) {
            state.items.forEach { item ->
                Div(attrs = { classes("bulk-delete-row", "bulk-${item.state.name.lowercase()}") }) {
                    Span(attrs = { classes("bulk-delete-mark") }) {
                        Text(when (item.state) { BulkItemState.WAITING -> "·"; BulkItemState.DELETING -> "…"; BulkItemState.DONE -> "✓"; BulkItemState.FAILED -> "✗" })
                    }
                    Span(attrs = { classes("bulk-delete-name") }) { Text(item.name) }
                    if (item.state == BulkItemState.FAILED && item.reason != null) Span(attrs = { classes("bulk-delete-reason") }) { Text(item.reason) }
                    if (item.state == BulkItemState.DELETING) Span(attrs = { classes("bulk-delete-reason") }) { Text("deleting") }
                }
            }
        }
    }
}
